export const US_English_Locale = "en-us";
export const ObstructionMetaDeviceID = 999999;
export const FeetMetersConversion = 3.28084;

export const ValidInputCharsRegEx = /^[A-Za-z0-9 _\-.()]+$/;
export const ValidInputCharsCrLfRegEx = /^[A-Za-z0-9 _\-.()\r\n]+$/;

export const DecimalToUndredthsRegEx = /^\d*\.?\d?\d?$/;
